module.exports = __webpack_public_path__ + "media/images/flags/4x3/kir-3fe8bdea3cf870387b4055ef14645709.svg";